// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Navidad'.toLowerCase()) > -1) {
    specialProduct1 = true;
  }   
}

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (specialProduct1) {
	  picker.set('disable', [true, 
                             { from: [2020, 8, 10], to: [2024, 11, 4] }, 
                             { from: [2024, 11, 25], to: [2024, 11, 25] }, 
                             { from: [2025, 0, 1], to: [2025, 0, 1] }, 
                             { from: [2025, 0, 6], to: [2035, 11, 24] }, 
                             
                            ]);
      picker.set('max', 100);
      
  } else {
      picker.set('disable', blackoutdatesCollection);
  }  
}

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  if (specialProduct1) {
  	timepicker.set('min',[10, 0]); 
    timepicker.set('max',[12, 0]);
    timepicker.set('interval',15);
  }
	
}